import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Activetable from "./Activetable";
import Blockedtable from "./Blockedtable";
import SearchBar from "material-ui-search-bar";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import Divider from "@material-ui/core/Divider";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import { hashtagListingService } from "../../../services/index";
import Utils from "../../../utility";
// import Divider from '@material-ui/core/Divider'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Typography>{children}</Typography>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background,
    width: "100%",
    "& hr": {
      margin: theme.spacing(1, 0.5),
      backgroundColor: "#707070",
    },
  },
  Tabs: {
    bgcolor: "whitesmoke",
    fontWeight: "bold",
  },
  Grid: {
    width: "100%",
    alignItems: "center",
    justify: "center",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    padding: '0px 0px 3px 1px',
  },
  iconButton: {
    maxWidth: 30,
    maxHeight: 25,
  },
  search: {
    height: 41,
    padding: "2px 4px 0 0",
    display: "flex",
    alignItems: "center",
    "@media (min-width: 768px) and (max-width: 1024px)": {
      display: "none",
    },
  },
  indicator: {
    height: 3,
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#FF0027",
    borderRadius: 2,
    marginLeft: 6,
    maxWidth: 146,
  },
  hastag: {
    width: "59%",
    "@media (min-width: 768px) and (max-width: 1024px)": {
      width: "26%",
    },
  },
}));

export default function FullWidthTabs(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [keyword, setKeyword] = React.useState("");
  const [activeHashtagListing, setActivehashtagListing] = React.useState([]);
  const [blockHashtagListing, setBlockhashtagListing] = React.useState([]);
  const [activeHashCount, setActiveHashCount] = React.useState([]);
  const [blockedHashCount, setBlockHashCount] = React.useState([]);


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  useEffect(() => {
    let data = {
      pageNum: 0,
      // perpage: activeHashCount,
      perpage: 10,
    };
    getActiveHashtagListing(data);
  }, [activeHashCount]);

  useEffect(() => {
    let data = {
      pageNum: 0,
      perpage: blockedHashCount,
    };

    getBlockHashtagListing(data);
  }, [blockedHashCount]);

  const getActiveHashtagListing = async (data) => {
    let [error, Hashtags] = await Utils.parseResponse(
      hashtagListingService.gethashtagListing(data)
    );

    setActivehashtagListing(Hashtags?.activeHashtags);
    setActiveHashCount(Hashtags?.activeCount);

    if (error || !Hashtags) return;
  };

  const getBlockHashtagListing = async (data) => {
    let [error, Hashtags] = await Utils.parseResponse(
      hashtagListingService.gethashtagListing(data)
    );

    setBlockhashtagListing(Hashtags?.blockedHashtags);
    setBlockHashCount(Hashtags?.blockedCount);
    if (error || !Hashtags) return;
  };


  const handleSearchIcon = () => {
    let searchkeyword = keyword;
      let data = {
        key: searchkeyword,
      };
      onChangeSearch(data);
  };

  const onChangeSearch = async (data) => {
    const [error, res] = await Utils.parseResponse(
      hashtagListingService.searchHashtags(data)
    );

    if (error || !res) return;
    // console.log("res---", res?.blockHash);

    setActivehashtagListing(res?.activeHash);
    setBlockhashtagListing(res?.blockHash);
  };

  return (
    <div className={classes.root}>
      <Grid
        container
        p={3}
        direction="row"
        justifyContent="space-around"
        alignItems="center"
        spacing={3}
        className={classes.Grid1}
      >
        <Grid item md={4}></Grid>

        <Grid item className={classes.hastag} md={5}>
          <AppBar
            elevation={0}
            position="static"
            color="white"
            style={{ display: "table-row" }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              classes={{ indicator: classes.indicator }}
            >
              <Tab
                label="Active"
                {...a11yProps(0)}
                style={{ textTransform: "capitalize", color: "#1f1f1f" }}
              onClick={()=>{props.getTabActiveHashtagListing()
                getActiveHashtagListing()}}/>{" "}
              <Divider orientation="vertical" flexItem />
              {/* <Tab label="Reported" {...a11yProps(1)} /> */}
              <Tab
                label="Blocked"
                {...a11yProps(2)}
                style={{ textTransform: "capitalize", color: "#1f1f1f" }}
                onClick={()=>{props.getTabBlockHashtagListing() 
                  getBlockHashtagListing()}}
              />
            </Tabs>
          </AppBar>
        </Grid>
        <Grid item md={1}></Grid>
        <Grid item md={2}>
          <Paper component="form" className={classes.search}>
            <InputBase
              className={classes.input}
              placeholder="search"
              inputProps={{ "aria-label": "search " }}
              onChange={(e) => { setKeyword(e.target.value); handleSearchIcon(); }}
            />
            <IconButton
              // type="submit"
              className={classes.iconButton}
              aria-label="search"
              onClick={handleSearchIcon}
            >
              <img src="/images/searchicon.png" />
            </IconButton>
          </Paper>
        </Grid>
      </Grid>

      <br />
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.Grid}>
        <TabPanel value={value} index={0}>
          <Activetable
            isLoading={props?.isLoading}
            hashtagListing={activeHashtagListing}
            activeHashCount={activeHashCount}
            gethashtagListing={getActiveHashtagListing}
            tabActiveHashtagListing={props?.tabActiveHashtagListing}
            getTabActiveHashtagListing={props?.getTabActiveHashtagListing}
          />
        </TabPanel>

        <TabPanel value={value} index={2}>
          <Blockedtable
            isLoading={props?.isLoading}
            blockHashtagListing={blockHashtagListing}
            blockedHashCount={blockedHashCount}
            getBlockHashtagListing={getBlockHashtagListing}
            tabBlockHashtagListing={props?.tabBlockHashtagListing}
            getTabBlockHashtagListing={props?.getTabBlockHashtagListing}
          />
        </TabPanel>
      </Grid>
    </div>
  );
}
